<template>
	<div class="numeric-keyboard-component m-2" >
		<div class="row digits p-2">
			<button class="col-4 text-center digit border-bottom border-right" @click="clickLocal('1')">1</button>
			<button class="col-4 text-center digit border-bottom" @click="clickLocal('2')">2</button>
			<button class="col-4 text-center digit border-bottom border-left" @click="clickLocal('3')">3</button>
			<button class="col-4 text-center digit border-bottom border-right" @click="clickLocal('4')">4</button>
			<button class="col-4 text-center digit border-bottom" @click="clickLocal('5')">5</button>
			<button class="col-4 text-center digit border-bottom border-left" @click="clickLocal('6')">6</button>
			<button class="col-4 text-center digit border-bottom border-right" @click="clickLocal('7')">7</button>
			<button class="col-4 text-center digit border-bottom" @click="clickLocal('8')">8</button>
			<button class="col-4 text-center digit border-bottom border-left" @click="clickLocal('9')">9</button>
			<button class="col-4 text-center digit border-right" @click="clickLocal(extra1)"><span :class="class_extra1">{{ extra1 }}</span></button>
			<button class="col-4 text-center digit" @click="clickLocal(0)">0</button>
			<button class="col-4 text-center digit border-left " @click="clickLocal(extra2)"><span :class="class_extra2">{{extra2}}</span></button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NumericKeyboardComponent',
	props: ['extra1', 'extra2', 'class_extra1', 'class_extra2'],
	data() {
		return {}
	},
	methods: {
		initComponentLocal() {
		},
		clickLocal(val) {
			if(val != undefined && val != null){
				this.$emit('clickDigit', val)
			}
		}
	},
	mounted() {
		this.initComponentLocal()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.numeric-keyboard-component {
		.digits {
			width: 100%;
			//max-width: 300px;
			.digit {
				font-size: 32px;
			}
			.digit-small {
				font-size: 16px;
			}
			.digit-small-small {
				font-size: 12px;
			}
		}
	}
</style>
